// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sUHA","colBig":"styles_colBig__33KmV","colSmall":"styles_colSmall__1UKEz"};